/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import { TopologySubDomain } from '../../alarm-template-ngrx/_models/alarm-template';
import { Contact } from '../models/contact-model';

// Channel types
export const CHANNEL_TYPES = {
  EMAIL: 'EmailNotificationChannelConfig' as const,
  INTEGRATION: 'IntegrationNotificationChannelConfig' as const,
  EMAIL_NOTIFICATION_CHANNEL: 'EmailNotificationChannel' as const,
  INTEGRATION_NOTIFICATION_CHANNEL: 'IntegrationNotificationChannel' as const,
} as const;

// Form field types for JSON schema rendering
export const INPUT_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  URL: 'url',
  PASSWORD: 'password',
  NUMBER: 'number',
  CHECKBOX: 'checkbox',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  DATE: 'date'
} as const;

// Integration type configuration interface
export interface IntegrationTypeConfig {
  id: string;
  name: string;
  configurationSchema: string;
  isEnabled: boolean;
}

// Form field interface for dynamic form generation
export interface FormField {
  key: string;
  label: string;
  inputType: string;
  required: boolean;
  options?: { value: any; label: string }[];
}

export interface NotificationChannel {
  id: string;
  type: string;
  integrationType?: string;
  integrationConfig?: string;
  alarmTemplates?: any[];
  alarmTemplatesCount?: number;
  domains?: TopologySubDomain[];
  name: string;
  description: string;
  messageTitle: string;
  messageBody: string;
  lastUpdatedTimestamp: string;
  messageBodyMediaType: 'text/plain';
  recipients: Contact[];
  ccRecipients?: Contact[];
  disabled: boolean;
}
